import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import {
  CheckIcon,
  Link,
  Table,
  TableActions,
  TableColumn,
  TableContainer,
  Typography,
} from '_template';
import DateTime from 'components/DateTime';
import ButtonDelete from 'components/ButtonDelete';
import { GetEmailListQuery } from 'modules/Email/query';
import EmailDetail from 'modules/Email/components/EmailDetail';

interface ConsultantEmailListProps {
  consultantId: string;
}

const ConsultantEmailList = ({ consultantId }: ConsultantEmailListProps) => {
  const { t } = useTranslation();
  const [emailDetail, setEmailDetail] = useState<GQL.IEmail | null>(null);

  const emailListQuery = useQuery(GetEmailListQuery, {
    variables: {
      where: {
        externalObject: 'consultant',
        externalId: consultantId,
      },
      limit: {
        limit: 10000,
        offset: 0,
      },
      orderBy: {
        sortField: 'createdAt',
        sortBy: 'DESC',
      },
    },
    fetchPolicy: 'cache-and-network',
  });

  const { data, loading, error, refetch } = emailListQuery;

  const emails = data?.emailList?.rows || [];

  const handleClick = (data: GQL.IEmail) => {
    setEmailDetail(data);
  };

  return (
    <>
      {emailDetail && (
        <EmailDetail data={emailDetail} onClose={() => setEmailDetail(null)} />
      )}
      <TableContainer>
        <Table<GQL.IEmail>
          dataSource={emails}
          recordsCount={emails?.length}
          loading={loading}
          error={error}
          disablePaginate
        >
          <TableColumn
            label={t('EMAIL.CREATED_AT')}
            dataIndex="createdAt"
            sx={{ width: 150 }}
            align="center"
            render={({ createdAt }: GQL.IEmail) => (
              <DateTime value={createdAt} />
            )}
          />
          <TableColumn
            label={t('EMAIL.RECIPIENT')}
            dataIndex="recipient"
            sx={{ width: 300 }}
            render={(row: GQL.IEmail) => (
              <Typography>{row.recipient?.join(', ')}</Typography>
            )}
          />
          <TableColumn
            label={t('EMAIL.SUBJECT')}
            dataIndex="subject"
            render={(row: GQL.IEmail) => (
              <Link onClick={() => handleClick(row)}>{row.subject}</Link>
            )}
          />
          <TableColumn
            label={t('EMAIL.SENDED')}
            dataIndex="sended"
            align="center"
            sx={{
              display: {
                xs: 'none',
                sm: 'table-cell',
                width: '70px',
              },
            }}
            render={({ sendedAt }: GQL.IEmail) => (
              <CheckIcon value={!!sendedAt} withColor />
            )}
          />
          <TableActions
            render={(row: GQL.IEmail) => {
              return (
                <ButtonDelete
                  message={t('FILE.REALLY_TO_DELETE')}
                  disabled
                  // onDelete={() => deleteFile({ variables: { id: row.id } })}
                  refetch={refetch}
                />
              );
            }}
          />
        </Table>
      </TableContainer>
    </>
  );
};

export default ConsultantEmailList;
